const REG_PHONE_10_DIGITS = /^0\d{9}$/;
const REG_PHONE_11_DIGITS = /^0\d{10}$/;
export {
  REG_PHONE_10_DIGITS,
  REG_PHONE_11_DIGITS
};
